<script>
import axios from 'axios'
import { BaseURL } from '../shared/classes'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Vue from 'vue'
const formShape = {
  reason: '',
  comments: ''
}
export const EventBus = new Vue()

export default {
  name: 'reason-popup',
  data () {
    return {
      userid: '',
      form: Object.assign({}, formShape),
      base_urls: BaseURL,
      reasonList: [],
      postdatas: [],
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      profiledetails: [],
      userInfo: JSON.parse(localStorage.getItem('user__details'))
    }
  },
  props: {
    shwovalueReason: {
      type: Boolean,
      required: false
    }
  },
  created () {
    this.shwovalueReason = true
    this.posts = JSON.parse(localStorage.getItem('postId'))
    this.interviewer = JSON.parse(localStorage.getItem('viewid'))
    this.userid = JSON.parse(localStorage.getItem('viewid'))
    this.selectpost = JSON.parse(localStorage.getItem('postId'))
    this.getreasondata()
    this.getdata()
    this.form.reason = ''
    this.form.comments = ''
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      reason: {
        required
      },
      comments: {
      }
    }
  },
  methods: {
    getreasondata () {
      axios.get(BaseURL + '/dashboard/get_cancel_reason/web', this.config).then(response => {
        this.reasonList = response.data.reasonlist
      }).catch(e => {
      })
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    SendMessageToParent () {
      this.$root.$emit('message_from_abc', this.selectpost)
    },
    close () {
      this.$emit('input', !this.shwovalueReason)
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    onSubmitProfile () {
      this.userInfo = JSON.parse(localStorage.getItem('user__details'))
      if (this.validate()) {
        console.log('no error')
        this.$nextTick(() => {
          this.postdatas = []
          let mainurl = ''
          if (JSON.parse(localStorage.getItem('reschedule')) === 'cancelOrg') {
            this.postdatas = {
              _id: JSON.parse(localStorage.getItem('sid')),
              reason_comments: this.form.comments,
              reason_id: this.form.reason._id,
              reason_name: this.form.reason.value
            }
            mainurl = '/dashboard/cancel_schedule_newreq'
            // mainurl = '/dashboard/reschedule_cancel'
          } else if (JSON.parse(localStorage.getItem('reschedule')) === 'cancelResch') {
            this.postdatas = {
              _id: JSON.parse(localStorage.getItem('sid')),
              reason_comments: this.form.comments,
              reason_id: this.form.reason._id,
              reason_name: this.form.reason.value,
              cancel_by: 'organization'
            }
            mainurl = '/dashboard/reschedule_cancel_newreq'
            // mainurl = '/dashboard/reschedule_cancel'
          } else if (JSON.parse(localStorage.getItem('reschedule')) === 'decline') {
            this.postdatas = {
              _id: JSON.parse(localStorage.getItem('sid')),
              reason_comments: this.form.comments,
              reason_id: this.form.reason._id,
              reason_name: this.form.reason.value,
              cancel_by: 'organization'
            }
            mainurl = '/dashboard/reschedule_declined'
          } else if (JSON.parse(localStorage.getItem('reschedule')) === 'decline1') {
            this.postdatas = {
              _id: JSON.parse(localStorage.getItem('sid')),
              reason_comments: this.form.comments,
              reason_id: this.form.reason._id,
              reason_name: this.form.reason.value,
              cancel_by: 'organization'
            }
            mainurl = '/dashboard/declined_schedule/web'
          } else {
            console.log(localStorage.getItem('sid'))
            mainurl = '/dashboard/cancel_schedule/web'
            this.postdatas = {
              _id: JSON.parse(localStorage.getItem('sid')),
              reason_comments: this.form.comments,
              reason_id: this.form.reason._id,
              reason_name: this.form.reason.value
            }
          }
          // if (this.profiledetails.scheduleid !== null && this.profiledetails.scheduleid !== undefined) {
          //   console.log(JSON.parse(localStorage.getItem('reschedule')))
          //   if (JSON.parse(localStorage.getItem('reschedule')) === 'cancelOrg') {
          //     this.postdatas = {
          //       _id: JSON.parse(localStorage.getItem('sid')),
          //       reason_comments: this.form.comments,
          //       reason_id: this.form.reason._id,
          //       reason_name: this.form.reason.value
          //     }
          //     mainurl = '/dashboard/cancel_schedule_newreq'
          //     // mainurl = '/dashboard/reschedule_cancel'
          //   } else if (JSON.parse(localStorage.getItem('reschedule')) === 'decline') {
          //     this.postdatas = {
          //       _id: JSON.parse(localStorage.getItem('sid')),
          //       reason_comments: this.form.comments,
          //       reason_id: this.form.reason._id,
          //       reason_name: this.form.reason.value,
          //       cancel_by: 'organization'
          //     }
          //     mainurl = '/dashboard/reschedule_declined'
          //   } else if (JSON.parse(localStorage.getItem('reschedule')) === 'decline1') {
          //     this.postdatas = {
          //       _id: JSON.parse(localStorage.getItem('sid')),
          //       reason_comments: this.form.comments,
          //       reason_id: this.form.reason._id,
          //       reason_name: this.form.reason.value,
          //       cancel_by: 'organization'
          //     }
          //     mainurl = '/dashboard/declined_schedule/web'
          //   } else {
          //     console.log(localStorage.getItem('sid'))
          //     mainurl = '/dashboard/cancel_schedule/web'
          //     this.postdatas = {
          //       _id: JSON.parse(localStorage.getItem('sid')),
          //       reason_comments: this.form.comments,
          //       reason_id: this.form.reason._id,
          //       reason_name: this.form.reason.value
          //     }
          //   }
          // } else {
          //   console.log(this.profiledetails.status)
          //   if (this.profiledetails.status === 'Accepted') {
          //     this.postdatas = {
          //       post_id: this.selectpost,
          //       user_id: this.userid,
          //       org_id: this.userInfo._id,
          //       comments: this.form.comments,
          //       reason_id: this.form.reason._id,
          //       reason_name: this.form.reason.value,
          //       tobe_cancel_by: 'web'
          //     }
          //     mainurl = '/dashboard/cancel_tobeschedule'
          //   } else {
          //     this.postdatas = {
          //       post_id: this.selectpost,
          //       user_id: this.userid,
          //       org_id: this.userInfo._id,
          //       comments: this.form.comments,
          //       reason_id: this.form.reason._id,
          //       reason_name: this.form.reason.value
          //     }
          //     mainurl = '/dashboard/update_org_uninterest/web'
          //   }
          // }
          axios.post(`${this.base_urls}${mainurl}`, { formData: this.postdatas }, this.config).then(response => {
            localStorage.setItem('reschedule', JSON.stringify('accept'))
            this.$root.$emit('message_from_tobe', this.selectpost)
            const optionsOverrides = {
              durations: {
                global: 3000
              },
              labels: {
                success: '',
                warning: ''
              },
              position: 'bottom-right'
            }
            this.$awn.success('Cancelled Successfully', optionsOverrides)
            // if (this.profiledetails.status === 'Accept') {
            //   this.$awn.success('Declined Successfully', optionsOverrides)
            // } else {
            //   this.$awn.success('Cancelled Successfully', optionsOverrides)
            // }
            this.SendMessageToParent()
            this.close()
          }).catch(e => {
            console.log(e)
          })
        })
      } else {
        console.log('validation fail................')
      }
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    getdata () {
      const mainurl = '/dashboard/get_profile_detail/' + this.userid + '/' + this.selectpost + '/' + this.userInfo._id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.profiledetails = response.data.profileDetail[0]
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<template>
<!-- <div class="custom-modal-backdrop" v-show="shwovalueReason">  -->
  <div class="modal fade1 in" id="modal-default" style="display: block;" v-show="shwovalueReason">
  <div class="modal-dialog" style="margin-top:15px">
    <div class="modal-content">
      <!-- <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" @click="close()">×</span></button>
        <h4>Schedule</h4>
      </div> -->
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12 ">
            <span data-dismiss="modal" @click="close()" class="pop-up-close-icon"><i aria-hidden="true" class="uil uil-times"></i></span>
            <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" @click="close()">×</span></button> -->
            <!-- <h4 v-if="profiledetails.status != 'Accept'">Reason for Cancellation</h4>
            <h4 v-if="profiledetails.status == 'Accept'">Reason for Declining</h4> -->
            <h4>Reason for Cancellation</h4>
            <hr>
            <!-- start form -->
            <b-form class="register-form" v-on:submit.prevent="onSubmitProfile" novalidate>
              <div class="box-body">
                <div class="form-group">
                  <label for="inputEmail3" class="col-sm-2 control-label">Reason</label>
                  <div class="col-sm-10" style="margin-bottom: 10px;">
                    <div class="form-group">
                        <div class="form-select">
                          <select id="reason" v-model="form.reason" class="form-control is-valid" v-bind:class="{ 'is-invalid': !chkState('reason') }">
                            <option value=''>Select the Reason *</option>
                            <option v-for="x in reasonList" v-bind:value="x" :key="x.value">{{x.value}}</option>
                          </select>
                          <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                        </div>
                      </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="inputPassword3" class="col-sm-2 control-label">Comments</label>

                  <div class="col-sm-10">
                      <b-form-textarea v-model.lazy.trim="$v.form.comments.$model" :state="chkState('comments')" class="textarea" rows="5" placeholder="Enter Comments*"></b-form-textarea>
                  </div>
                </div>
                <!-- <div class="form-group">
                  <div class="col-sm-offset-2 col-sm-10">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" style="margin-left: -196px;"> Remember me
                      </label>
                    </div>
                  </div>
                </div> -->
              </div>
              <!-- /.box-body -->
              <hr>
                <div class="form-submit">
                  <input type="submit" value="Submit" class="submit" name="submit" id="submit" />
                </div>
              <!-- /.box-footer -->
              </b-form>
            <!-- form end -->
          </div>
        </div>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
</div>
</template>
<style scoped>
@media screen and (min-width: 769px){
  .modal-content, .modal-card {
      margin: 0 auto;
      width: 801px;
  }
}
.modal { overflow: auto !important; }
.modal-header {
  padding: 8px !important;
}
.modal-header {
  background-color: #F5F5F5;
  border-bottom: 1px solid #cccccc73;
}
hr {
    border-top: 1px solid #55555538 !important;
}
hr {
  margin-top: 5px;
  margin-bottom: 5px;
}
button.close {
    padding: 7px;
}
.form-control.is-invalid {
    border-color: #f86c6b !important;
}
.modal-content {
    width: 520px;
}
</style>
